import operateState from '../components/operate-state';
import receiptDialog from '../components/receipt-dialog';
import { cancelReceipt } from '@/api/receivables/receipt';

const receiptMixins = {
  components: { operateState, receiptDialog },
  data() {
    return {
      receiptObj: {}, // 收款单对象
      textConfig: {}, // 弹窗页面提示文案
      isOperateStateShow: false, // 确认/取消确认弹窗
      receiptShow: false, // 金融收款弹窗
      cancelLoading: false,
      isOperateCancelShow: false,
    };
  },
  methods: {
    /**
     * 确认操作是否展示
     */
    handleConfirmShow(row) {
      // 待确认 && isFlow 针对金融收款(9) 1\2显示确认按钮 0不显示
      if ([1, '1'].includes(row.verifiedStatus) && row.receiptMode === 9 && [1, 2].includes(row.isFlow)) {
        return true;
      }
      // 待确认 && 不为线上二维码(2)、公众号支付(3)、小程序支付(4)、银行卡快捷(7)、金融收款(9)
      if ([1, '1'].includes(row.verifiedStatus) && ![2, 3, 4, 6, 7, 9].includes(row.receiptMode)) {
        return true;
      }
      return false;
    },
    /**
     * 取消按钮是否展示
     * 待确认 && 线下收款(1)
     */
    handleCancelShow(row) {
      if ([1, '1'].includes(row.verifiedStatus) && row.receiptMode === 1) {
        return true;
      }
      return false;
    },
    /**
     * 收款单确认/取消确认
     * receiptNo     收款单编号
     * operation     操作：1、确认 2、作废 3、取消确认
     * cancelRemark  取消确认原因，取消确认时传入
    */
    handleOperateState(operation, row) {
      // 金融收款 需弹窗勾选对应的对账薄数据进行确认
      if (row.receiptMode === 9 && row.isFlow === 1) {
        this.receiptShow = true;
        this.receiptObj = { ...row };
        return;
      }
      this.receiptObj = {
        receiptNo: row?.receiptNo || '',
        operation,
        cancelRemark: '',
      };

      const list = {
        1: {
          title: '人工确认',
          messageTip: '是否人工确认该笔收款单？（收款单确认后，将无法取消，请谨慎操作。）',
        },
        3: {
          title: '取消确认',
          messageTip: '是否取消确认该笔收款单？',
        },
      };
      this.textConfig = list[operation] || '-';
      this.isOperateStateShow = true;
    },
    // 取消
    handleCancel(row) {
      this.receiptObj = {
        receiptNo: row.receiptNo,
      };
      this.textConfig = {
        title: '是否取消该笔收款单?',
        messageTip: '取消原因',
      };
      this.isOperateCancelShow = true;
    },
    async cancelReceipt(params) {
      try {
        this.cancelLoading = true;
        await cancelReceipt({
          receiptNo: params.receiptNo,
          remark: params.cancelRemark || '',
        });
        this.$message.success('操作成功！');
        this.cancelLoading = false;
        this.isOperateCancelShow = false;
        this.handleOperateStateResults();
      } catch (error) {
        console.log(error);
        this.cancelLoading = false;
      }
    },
  },
};

export default receiptMixins;
